import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { saveImageVM } from '../../entities/global/model';
import { SafetyGeneraldashboardService } from '../../services/safety-generaldashboard.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-image-dialog',
  templateUrl: './add-image-dialog.component.html',
  styleUrls: ['./add-image-dialog.component.css']
})
export class AddImageDialogComponent implements OnInit {
  selectedFile: File;

  constructor(public dialogRef:MatDialogRef<AddImageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _safetyGeneraldashboardService: SafetyGeneraldashboardService,
    private _sanitizer: DomSanitizer,) { }

    public attachment;
    ImageID
    

  ngOnInit() {
    this.Image=this.data.Image
  }
  public Image;
  QuestionName=this.data.QuestionName
 
  
  DialogClose(){
    this.dialogRef.close(false)
  }

  sanitize(image: string) {
    console.log(Image)
    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`); 
  }
  uploadPhoto(newPhoto: string) {

    this.Image = newPhoto.split(",")[1];
    
    this.data.Image = this.Image;
    //this.data.imageName_comp = this.selectedFile.name;
  }

  onSelectPhoto(event: any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.selectedFile = event.target.files[0];
      reader.onloadend = (e) => {
        this.uploadPhoto(reader.result as string);
        
      }
      reader.readAsDataURL(event.target.files[0]);
    }
  }
 



  saveImage() {
   let model= new saveImageVM()
   model.Id=this.data.ObservationQuestionId;
   model.Image=this.Image;
   model.imageID=this.ImageID;
    this._safetyGeneraldashboardService.SaveQuestionImage(model)
    .subscribe(r => {
     
      this.dialogRef.close();
    
    });
  }

}
